module.exports = __webpack_public_path__ + "static/startPage_thumb-43c06319c29638fe3998a169aff370e2.jpeg";